import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";

import { container, main } from "assets/jss/material-kit-pro-react.jsx";

const styles = theme => ({
  main,
  container,
  content: {
    flexGrow: 1,
    height: "85vh",
    backgroundColor: "white"
  },
  appBarSpacer: theme.mixins.toolbar
});

class NotFound extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.content}>
        <div className={classes.appBarSpacer} />
        <div className={classes.main} style={{ marginTop: 5 }}>
          <div
            className={classes.container}
            style={{ display: "flex", margin: "auto", textAlign: "center" }}
          >
            <div style={{ maxWidth: 600, margin: "auto" }}>
              <h1>404</h1>
              <h2>Oops! This Page Could Not Be Found.</h2>
              <p style={{ fontSize: 16 }}>
                Sorry, But the page you are looking for deos not exist, have
                been removed, name changed or is temporarily unavailable.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(NotFound);
